import { render, staticRenderFns } from "./InquiryListView.vue?vue&type=template&id=6fb8e326"
import script from "./InquiryListView.vue?vue&type=script&lang=js"
export * from "./InquiryListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports